import WebMidi from "webmidi"

class MidiMaestro {

    constructor(){
        this.subscribers = [];
        WebMidi.enable( (err)=> {
            console.log(WebMidi.inputs);
            console.log(WebMidi.outputs);

            let input = WebMidi.getInputByName("Ableton Push 2 Live Port")
            if(!input)return;
            input.addListener('noteon', 'all', (event) => {
                console.log(event.data)
                console.log(event.note)

                this.subscribers.forEach ((subscriber=> {
                    subscriber.onNote();
                }))
            })

        })

        addEventListener('keydown', (event) => {
            if(event.key === 'm') {
                console.log('midi')
                this.subscribers.forEach((subscriber) => {
                    
                    subscriber.onNote();
                })
            }
        });
    }

    addSubscriber(subscriber) {
        this.subscribers.push(subscriber)
    }



}

export {MidiMaestro}

